import classNames from "../../utilities/ClassNames";
import AreaPage from "components/UnityCharts/charts/Area/Area";
import GaugePage from "components/UnityCharts/charts/Gauge/Gauge";
import GaugeBar from "components/UnityCharts/charts/GaugeBar/GaugeBar";
import Kpi from "components/UnityCharts/charts/Kpi/Kpi";
import Large from "components/UnityCharts/charts/Large/Large";
import OneGauge from "components/UnityCharts/charts/OneGauge/OneGauge";
import ColumnChart from "components/UnityCharts/charts/Column/Column";
import { cn } from "../../@/lib/utils";
import React from "react";
import { TabBodyProps } from "./domain/types";

const TabBody: React.FC<TabBodyProps> = ({
  screen,
  tabs,
  currentTab,
  setScreen,
  type,
  tabBodyConfig,
  hooks
}) => {
  const { largeConfig, kpiConfig, unityAreaConfig, unityGaugeConfig, unityColumnConfig, unityGaugeBarConfig, oneGaugeConfig } = tabBodyConfig;
  return (
    <div className={cn("relative px-3 lg:pb-3 xl:pb-3 2xl:pb-1", "h-[90%]")}>
      {tabs[currentTab]?.configured && tabs[currentTab].type === "large" && (
        <Large tab={tabs[currentTab]} largeConfig={largeConfig} hooks={hooks} />
      )}
      {tabs[currentTab]?.configured && tabs[currentTab].type === "kpi" && (
        <Kpi tab={tabs[currentTab]} kpiConfig={kpiConfig} hooks={hooks} />
      )}
      {screen !== "configuration" &&
        screen !== "newTab" &&
        tabs[currentTab]?.configured &&
        tabs[currentTab].type === "area" && (
          <AreaPage tab={tabs[currentTab]} unityAreaConfig={unityAreaConfig} hooks={hooks} />
        )}
      {screen !== "configuration" &&
        screen !== "newTab" &&
        tabs[currentTab]?.configured &&
        tabs[currentTab].type === "gauge" && (
          <GaugePage tab={tabs[currentTab]} unityGaugeConfig={unityGaugeConfig} hooks={hooks} />
        )}
      {screen !== "configuration" &&
        screen !== "newTab" &&
        tabs[currentTab]?.configured &&
        tabs[currentTab].type === "column" && (
          <ColumnChart tab={tabs[currentTab]} unityColumnConfig={unityColumnConfig} hooks={hooks} />
        )}
      {screen !== "configuration" &&
        screen !== "newTab" &&
        tabs[currentTab]?.configured &&
        tabs[currentTab]?.type === "gaugeBar" && (
          <GaugeBar tab={tabs[currentTab]} unityGaugeBarConfig={unityGaugeBarConfig} hooks={hooks} />
        )}
      {screen !== "configuration" &&
        screen !== "newTab" &&
        tabs[currentTab]?.configured &&
        tabs[currentTab]?.type === "oneGaugeBar" &&
        type !== 3 && (
          <div className="h-full bg-black rounded flex items-center justify-center">
            <OneGauge tab={tabs[currentTab]} oneGaugeConfig={oneGaugeConfig} hooks={hooks} />
          </div>
        )}
      {screen !== "configuration" &&
        screen !== "newTab" &&
        tabs[currentTab]?.configured &&
        tabs[currentTab]?.type === "oneGaugeBar" &&
        type === 3 && <OneGauge tab={tabs[currentTab]} oneGaugeConfig={oneGaugeConfig} hooks={hooks} />}
      {!tabs[currentTab]?.configurations && (
        <div className="flex justify-center items-center gap-3 h-full">
          <div className={classNames("")}>
            Tab is empty,{" "}
          </div>
          <div
            onClick={() => setScreen("configuration")}
            className={classNames(
              "cursor-pointer text-green"
            )}
          >
            Start Configuring
          </div>
        </div>
      )}
    </div>
  );
};

export default TabBody;